export default "__VITE_PUBLIC_ASSET__101cfb8c__"